export default __webpack_public_path__ + "static/media/Ramin.187ad179.gif";